import axios from 'axios';
import ipfs from 'decentralized/Ipfs.js';

export const downloadImage = (thumb) =>  {
    return new Promise((resolve, reject) => {
        axios.get('http://0.0.0.0:9092/' + thumb,
                  {
                      responseType: 'blob'
                  })
            .then(result => {
                let blob = result.data;
                ipfs.addBlob(blob).then((hash) => {
                    console.log('Downloaded thumb = ', hash);
                    resolve(hash);
                });
            });
    });
};
 
